(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-new-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (sliderEl) => {
      if (!sliderEl || sliderEl.dataset.sliderInitialized === 'true') return;
      if (typeof Swiper === 'undefined') return;

      const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
      if (!slidesCount) return;

      const toFloat = (value, fallback) => {
        const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
        return Number.isFinite(parsed) ? parsed : fallback;
      };
      const toInt = (value, fallback) => {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const mobile = toFloat(sliderEl.dataset.mobile, 1.25);
      const tablet = toFloat(sliderEl.dataset.tablet, 2.2);
      const desktop = toFloat(sliderEl.dataset.desktop, 3.9);
      const gapMobile = toInt(sliderEl.dataset.gapMobile, 12);
      const gapDesktop = toInt(sliderEl.dataset.gapDesktop, 16);
      const speed = toInt(sliderEl.dataset.speed, 450);
      const shouldLoop = slidesCount > Math.ceil(desktop);

      new Swiper(sliderEl, {
        slidesPerView: mobile,
        spaceBetween: gapMobile,
        speed,
        watchOverflow: true,
        loop: shouldLoop,
        pagination: {
          el: sliderEl.querySelector('.blog-new-section__pagination'),
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: tablet,
            spaceBetween: gapDesktop
          },
          1100: {
            slidesPerView: desktop,
            spaceBetween: gapDesktop
          }
        }
      });

      sliderEl.dataset.sliderInitialized = 'true';
    };

    const initAll = (scope = document) => {
      if (typeof Swiper === 'undefined') return false;
      const sliders = [];
      if (scope.matches && scope.matches('[data-blog-new-slider]')) sliders.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-blog-new-slider]').forEach((el) => sliders.push(el));
      }
      sliders.forEach((slider) => initSlider(slider));
      return sliders.length > 0;
    };

    const waitForSwiperAndInit = (scope = document) => {
      if (initAll(scope)) return;
      let attempts = 0;
      const maxAttempts = 25;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (initAll(scope) || attempts >= maxAttempts) {
          window.clearInterval(timer);
        }
      }, 120);
    };

    const runWhenIdle = (callback) => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 700 });
      } else {
        window.setTimeout(callback, 120);
      }
    };

    const observeAndInit = (scope = document) => {
      const sliders = [];
      if (scope.matches && scope.matches('[data-blog-new-slider]')) sliders.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-blog-new-slider]').forEach((el) => sliders.push(el));
      }

      sliders.forEach((slider) => {
        if (slider.dataset.observerAttached === 'true') return;
        slider.dataset.observerAttached = 'true';

        if (!('IntersectionObserver' in window)) {
          runWhenIdle(() => waitForSwiperAndInit(slider));
          return;
        }

        const observer = new IntersectionObserver(
          (entries, instance) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              instance.unobserve(entry.target);
              runWhenIdle(() => waitForSwiperAndInit(entry.target));
            });
          },
          { rootMargin: '220px 0px' }
        );

        observer.observe(slider);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeAndInit(), { once: true });
    } else {
      observeAndInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      observeAndInit(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (sliderEl, sectionRoot) => {
      if (!sliderEl || sliderEl.dataset.sliderInitialized === 'true') return;
      if (typeof Swiper === 'undefined') return;

      const slidesCount = sliderEl.querySelectorAll('.swiper-slide').length;
      if (!slidesCount) return;

      const toFloat = (value, fallback) => {
        const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const toInt = (value, fallback) => {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const mobile = toFloat(sliderEl.dataset.mobile, 3.5);
      const tablet = toFloat(sliderEl.dataset.tablet, 5);
      const desktop = toFloat(sliderEl.dataset.desktop, 9);
      const gapMobile = toInt(sliderEl.dataset.gapMobile, 16);
      const gapDesktop = toInt(sliderEl.dataset.gapDesktop, 24);
      const speed = toInt(sliderEl.dataset.speed, 400);
      const enableLoop = sliderEl.dataset.loop === 'true';
      const showNavigation = sliderEl.dataset.navigation === 'true';
      const shouldLoop = enableLoop && slidesCount > Math.ceil(desktop);

      const config = {
        slidesPerView: mobile,
        spaceBetween: gapMobile,
        speed,
        watchOverflow: true,
        loop: shouldLoop,
        simulateTouch: true,
        grabCursor: true,
        touchRatio: 1,       
        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
          releaseOnEdges: true,
          eventsTarget: 'container'
        },
        breakpoints: {
          230: {
            slidesOffsetBefore: 31,
            slidesOffsetBefore: 31            
          },
          768: {
            slidesPerView: tablet,
            spaceBetween: gapDesktop,
            slidesOffsetBefore:0,
            slidesOffsetBefore:0
          },
          990: {
            slidesPerView: desktop,
            spaceBetween: gapDesktop
          }
        }
      };

      if (showNavigation && sectionRoot) {
        config.navigation = {
          nextEl: sectionRoot.querySelector('.category-collection__nav--next'),
          prevEl: sectionRoot.querySelector('.category-collection__nav--prev')
        };
      }

      new Swiper(sliderEl, config);
      sliderEl.dataset.sliderInitialized = 'true';
    };

    const initAll = (scope = document) => {
      if (typeof Swiper === 'undefined') return false;

      const sections = [];
      if (scope.matches && scope.matches('.category-collection')) sections.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll('.category-collection').forEach((el) => sections.push(el));
      }

      sections.forEach((sectionRoot) => {
        const sliderEl = sectionRoot.querySelector('[data-category-collection-slider]');
        initSlider(sliderEl, sectionRoot);
      });

      return sections.length > 0;
    };

    const waitForSwiperAndInit = (scope = document) => {
      if (initAll(scope)) return;

      let attempts = 0;
      const maxAttempts = 25;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (initAll(scope) || attempts >= maxAttempts) {
          window.clearInterval(timer);
        }
      }, 120);
    };

    const runWhenIdle = (callback) => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(callback, { timeout: 700 });
      } else {
        window.setTimeout(callback, 120);
      }
    };

    const observeAndInit = (scope = document) => {
      const sections = [];
      if (scope.matches && scope.matches('.category-collection')) sections.push(scope);
      if (scope.querySelectorAll) {
        scope.querySelectorAll('.category-collection').forEach((el) => sections.push(el));
      }

      sections.forEach((sectionRoot) => {
        const sliderEl = sectionRoot.querySelector('[data-category-collection-slider]');
        if (!sliderEl || sliderEl.dataset.observerAttached === 'true') return;
        sliderEl.dataset.observerAttached = 'true';

        if (!('IntersectionObserver' in window)) {
          runWhenIdle(() => waitForSwiperAndInit(sectionRoot));
          return;
        }

        const observer = new IntersectionObserver(
          (entries, instance) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              instance.unobserve(entry.target);
              runWhenIdle(() => waitForSwiperAndInit(sectionRoot));
            });
          },
          { rootMargin: '200px 0px' }
        );

        observer.observe(sliderEl);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => observeAndInit(), { once: true });
    } else {
      observeAndInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      observeAndInit(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-review-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSlider = (sliderEl) => {
      if (!sliderEl || sliderEl.dataset.sliderInitialized === 'true') return;
      if (typeof Swiper === 'undefined') return;

      const totalSlides = sliderEl.querySelectorAll('.swiper-slide').length;
      if (totalSlides === 0) return;

      const toFloat = (value, fallback) => {
        const parsed = Number.parseFloat(String(value ?? '').replace(',', '.'));
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const mobile = toFloat(sliderEl.dataset.mobile, 1.1);
      const tablet = toFloat(sliderEl.dataset.tablet, 2.2);
      const desktop = toFloat(sliderEl.dataset.desktop, 3.5);     
      const gap = Number.parseInt(sliderEl.dataset.gap || '16', 10);
      const autoplaySeconds = Number.parseInt(sliderEl.dataset.autoplay || '0', 10);
      const speed = Number.parseInt(sliderEl.dataset.speed || '450', 10);
      const shouldLoop = totalSlides > Math.ceil(desktop);

      const config = {
        slidesPerView: mobile,
        centeredSlides: false,
        spaceBetween: gap,
        speed,
        watchOverflow: true,
        loop: shouldLoop,
        pagination: {
          el: sliderEl.querySelector('.customer-review__pagination'),
          clickable: true
        },
        breakpoints: {
          768: {
            slidesPerView: tablet,
            spaceBetween: gap
          },
          990: {
            slidesPerView: desktop,
            spaceBetween: gap
          }
        }
      };

      if (autoplaySeconds > 0) {
        config.autoplay = {
          delay: autoplaySeconds * 1000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      new Swiper(sliderEl, config);
      sliderEl.dataset.sliderInitialized = 'true';
    };

    const initAllSliders = (scope = document) => {
      if (typeof Swiper === 'undefined') return false;

      const sliders = [];
      if (scope.matches && scope.matches('[data-customer-review-slider]')) {
        sliders.push(scope);
      }
      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-customer-review-slider]').forEach((el) => sliders.push(el));
      }
      sliders.forEach((el) => initSlider(el));
      return sliders.length > 0;
    };

    const initWhenSwiperReady = (scope = document) => {
      if (initAllSliders(scope)) return;

      let attempts = 0;
      const maxAttempts = 20;
      const timer = window.setInterval(() => {
        attempts += 1;
        if (initAllSliders(scope) || attempts >= maxAttempts) {
          window.clearInterval(timer);
        }
      }, 120);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initWhenSwiperReady(), { once: true });
    } else {
      initWhenSwiperReady();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initWhenSwiperReady(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-and-shop"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const syncPlayIndicator = (video) => {
      if (!video) return;
      const indicator = video.closest('.watch-and-shop__media-shell')?.querySelector('.watch-and-shop__play-indicator');
      if (!indicator) return;

      indicator.style.display = video.paused ? 'block' : 'none';
    };

    const pauseVideo = (video) => {
      if (!video) return;
      video.pause();
      video.preload = 'none';
      syncPlayIndicator(video);
    };

    const pauseAllVideos = (swiper) => {
      const slides = swiper.slides || [];
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        pauseVideo(video);
      });
    };

    const bindPlayButtons = (sliderEl, swiper) => {
      const shells = sliderEl.querySelectorAll('.watch-and-shop__media-shell');
      shells.forEach((shell) => {
        const video = shell.querySelector('video');
        const indicator = shell.querySelector('.watch-and-shop__play-indicator');
        if (!video || !indicator || indicator.dataset.bound === 'true') return;

        syncPlayIndicator(video);

        indicator.addEventListener('click', () => {
          if (!video.paused) {
            pauseVideo(video);
            return;
          }

          pauseAllVideos(swiper);
          video.preload = 'metadata';
          const playAttempt = video.play();
          if (playAttempt && typeof playAttempt.catch === 'function') {
            playAttempt.catch(() => {});
          }
          syncPlayIndicator(video);
        });

        video.addEventListener('click', () => {
          if (video.paused) {
            pauseAllVideos(swiper);
            video.preload = 'metadata';
            const playAttempt = video.play();
            if (playAttempt && typeof playAttempt.catch === 'function') {
              playAttempt.catch(() => {});
            }
          } else {
            pauseVideo(video);
          }

          syncPlayIndicator(video);
        });

        video.addEventListener('play', () => syncPlayIndicator(video));
        video.addEventListener('playing', () => syncPlayIndicator(video));
        video.addEventListener('pause', () => syncPlayIndicator(video));
        video.addEventListener('ended', () => syncPlayIndicator(video));

        indicator.dataset.bound = 'true';
      });
    };

    const bindAddToCartButtons = (sliderEl) => {
      const buttons = sliderEl.querySelectorAll('[data-watch-and-shop-add-to-cart]');
      buttons.forEach((button) => {
        if (button.dataset.bound === 'true') return;

        const setButtonLoading = (isLoading) => {
          if (isLoading) {
            button.setAttribute('disabled', 'disabled');
            button.setAttribute('aria-busy', 'true');
            return;
          }

          button.removeAttribute('disabled');
          button.removeAttribute('aria-busy');
        };

        button.addEventListener('click', async () => {
          const variantId = button.dataset.variantId;
          if (!variantId) return;

          setButtonLoading(true);

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [
                  {
                    id: Number(variantId),
                    quantity: 1
                  }
                ],
                sections: 'cart-ajax'
              })
            });

            if (!response.ok) {
              throw await response.json();
            }

            const responseJson = await response.json();
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                bubbles: true,
                detail: {
                  product: responseJson,
                  addToCartBtn: button
                }
              })
            );
          } catch (error) {
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:error', {
                bubbles: true,
                detail: {
                  errorMessage: error?.description || error?.message || 'Unable to add product to cart.'
                }
              })
            );
            console.warn('Watch and shop add-to-cart failed', error);
          } finally {
            setButtonLoading(false);
          }
        });

        button.dataset.bound = 'true';
      });
    };

    const initSlider = (sliderEl) => {
      if (!sliderEl || sliderEl.dataset.sliderInitialized === 'true') return;

      const parseSlidesPerView = (value, fallback) => {
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      };
      const parsePositiveInteger = (value, fallback) => {
        const parsed = Number.parseInt(value, 10);
        return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
      };

      const slidesMobile = parseSlidesPerView(sliderEl.dataset.slidesMobile, 1.4);
      const slidesTablet = parseSlidesPerView(sliderEl.dataset.slidesTablet, 2.2);
      const slidesDesktop = parseSlidesPerView(sliderEl.dataset.slidesDesktop, 3.4);
      const sliderSpeed = parsePositiveInteger(sliderEl.dataset.sliderSpeed, 420);
      const autoplayDelay = parsePositiveInteger(sliderEl.dataset.autoplayDelay, 2600);
      const autoplayEnabled = sliderEl.dataset.autoplayEnabled === 'true';
      const totalSlides = sliderEl.querySelectorAll('.swiper-slide').length;
      const swiper = new Swiper(sliderEl, {
        effect: 'coverflow',
        slidesPerView: slidesMobile,
        centeredSlides: true,
        spaceBetween: 16,
        speed: sliderSpeed,
        loop: totalSlides > 2,
        autoplay: autoplayEnabled
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        watchSlidesProgress: true,
        grabCursor: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false
        },
        breakpoints: {
          800: {
            slidesPerView: slidesTablet,
            spaceBetween: 16,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 0,
              modifier: 1,
              slideShadows: false
            }
          },
          1300: {
            spaceBetween: 16,
            slidesPerView: slidesDesktop,
            coverflowEffect: {
              rotate: 0,
              stretch:0,
              depth:0,
              modifier: 1,
              slideShadows: false
            }
          }
        },
        on: {
          init() {
            pauseAllVideos(this);
          },
          slideChangeTransitionEnd() {
            pauseAllVideos(this);
          }
        }
      });

      bindPlayButtons(sliderEl, swiper);
      bindAddToCartButtons(sliderEl);

      sliderEl.dataset.sliderInitialized = 'true';
    };

    const getSlidersInScope = (scope = document) => {
      const sliders = [];
      if (scope.matches && scope.matches('[data-watch-and-shop-slider]')) {
        sliders.push(scope);
      }

      if (scope.querySelectorAll) {
        scope.querySelectorAll('[data-watch-and-shop-slider]').forEach((sliderEl) => {
          sliders.push(sliderEl);
        });
      }

      return sliders;
    };

    const initVisibleSliders = (scope = document) => {
      if (typeof Swiper === 'undefined') return false;

      const sliders = getSlidersInScope(scope);
      if (!sliders.length) return false;

      const supportsObserver = 'IntersectionObserver' in window;
      if (!supportsObserver) {
        sliders.forEach((sliderEl) => initSlider(sliderEl));
        return true;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const sliderEl = entry.target;
            initSlider(sliderEl);
            observer.unobserve(sliderEl);
          });
        },
        { rootMargin: '300px 0px', threshold: 0.01 }
      );

      sliders.forEach((sliderEl) => {
        if (sliderEl.dataset.sliderInitialized === 'true') return;
        observer.observe(sliderEl);
      });

      return true;
    };

    const initWhenSwiperReady = (scope = document) => {
      if (initVisibleSliders(scope)) return;

      let attempts = 0;
      const maxAttempts = 20;
      const retryTimer = window.setInterval(() => {
        attempts += 1;
        if (initVisibleSliders(scope) || attempts >= maxAttempts) {
          window.clearInterval(retryTimer);
        }
      }, 120);
    };

    const scheduleSliderInit = (scope = document) => {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(() => initWhenSwiperReady(scope), { timeout: 1200 });
        return;
      }

      window.setTimeout(() => initWhenSwiperReady(scope), 0);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => scheduleSliderInit(), { once: true });
    } else {
      scheduleSliderInit();
    }

    document.addEventListener('shopify:section:load', (event) => {
      scheduleSliderInit(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
